import { FunctionComponent, RefObject, useEffect, useRef } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { App, URLOpenListenerEvent } from '@capacitor/app'

const DeepLink: FunctionComponent = () => {
    const navigate: NavigateFunction = useNavigate()
    const prevUrlRef: RefObject<string> = useRef('')

    useEffect(() => {
        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            const slug: string | undefined = event.url.split('app.cald.fr').pop()
            if (slug && slug !== prevUrlRef.current) {
                navigate(slug)
                prevUrlRef.current = slug
            }
        })
    }, [])

    return null
}

export default DeepLink
